import React from "react"
import styles from "../../assets/styles/base/variables.scss"

export default function Style({ colour }: { colour: string }) {
  // Override highlight colour and scrollbar with case study colours
  return (
    <style>
      {`
    ::-webkit-scrollbar-track {
      background: #fff;
    }

    ::-webkit-scrollbar-thumb {
      background: ${colour};
    }

    ::selection {
      background: ${colour};
      color: #fff;
    }

    ::-moz-selection {
      background: ${colour};
      color: #fff;
    }
    #follower.follower-icon .follower-text{
      color: #fff;
      transform: translate(6%, 4%)
    }
    `}
    </style>
  )
}
